import React,{useState, useEffect} from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import GalleryTemplateEdit from "./Components/GalleryTemplateEdit.js";
import GalleryEdit from "./Components/GalleryEdit";
import Loader from "./Components/Loader.js";

const GalleryEditPage=()=>{

    useEffect(()=>{
        document.title="Edit Gallery | Balaji Badminton Academy"
      },[]);
      
    return(
        <>
            <Header/>
            <Loader/>
            <GalleryEdit/>
            <Footer/>
        </>
    );
}

export default GalleryEditPage;